import { MstColorLogic } from './MstColorLogic';
import { PinnedItemsReturnIntervals } from '@/constants/ReturnInterval';

export enum PinnedItemsChartTypes {
  SPIDER = 'Spider',
  LINE = 'Line',
  MST = 'MST',
}

export enum VolatilityAdjustmentOptions {
  NONE = 'None',
  VOLATILITY_PERCENT = 'Volatility',
}

export const volatilityAdjustmentOptions: readonly VolatilityAdjustmentOptions[] = [
  VolatilityAdjustmentOptions.NONE,
  VolatilityAdjustmentOptions.VOLATILITY_PERCENT,
] as const;

export const DEFAULT_PINNED_CHART_TYPE: PinnedItemsChartTypes = PinnedItemsChartTypes.LINE;
export const DEFAULT_PINNED_RETURN_INTERVAL: PinnedItemsReturnIntervals = PinnedItemsReturnIntervals.WEEKLY;
export const DEFAULT_PINNED_VOLATILITY_ADJUSTMENT: VolatilityAdjustmentOptions = VolatilityAdjustmentOptions.NONE;
export const DEFAULT_PINNED_COLOR_LOGIC: MstColorLogic = MstColorLogic.ASSET_CLASS;
export const DEFAULT_PINNED_SHOW_UNIVERSE = true;
